export { ReactComponent as TextStrikeThrough } from './svgs/strike-through.svg';
